import { render, staticRenderFns } from "./translation-input.vue?vue&type=template&id=3e31c890&"
import script from "./translation-input.vue?vue&type=script&lang=js&"
export * from "./translation-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports